module.exports = __webpack_public_path__ + "static/media/8.ea392339.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_110/images/九宫格未选中态/8.png
// module id = 1069
// module chunks = 0